{
  "v": "5.9.0",
  "fr": 30,
  "ip": 0,
  "op": 211,
  "w": 800,
  "h": 400,
  "nm": "Comp 1",
  "ddd": 0,
  "assets": [
    {
      "id": "image_0",
      "w": 56,
      "h": 55,
      "u": "",
      "p": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA3CAYAAABZ0InLAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAE7klEQVRogdVaTW8bVRQ95820UBBKs6BqFyiTFWqRgvkFTLbdNBIgRVUXE6kICwF1pS4iFmhEs8iiolOFtl6EMAGkdkUcVWKL/QtqFqhSNzYiG9RFsMSq2HNZOE7H328884x7VuM39913zzv3fY6JKaFw+SAHS7kAAMsuB+GZ6jTa5TQaKVw5CAS8RhIgQRBQuHM7PFsw3bZxgp9fPvCUwvcAESdIAqBa+yY8E5psX5l0DgAk/K7f8adIfBiGUYJfXPnTB7Aw1IBYuOH95ZuMwViKFrza6da/dp3gHNluijxK0066AiDZaOGEE4Tzf5uIw5iC0XNVADCnYTpnq6axycaIggWvdrr13KqDnDueUIYrCJKNpthGVDSiYFNfvQ6MqZi5gvnVmmNT1fqWhNEKAiBssRY3w/l6lvFkrqBF5U9at8lo4rrDkKmC+dWaY5E1DlrUByjYLu4usyKVqYqZKmhB+Wl7LMpYxcwU/Gy15gr4a1ytFwr2jzd29qREX5lSXN7cni9nEVdmCkbo3pLNiq/UCuZXa44SCUBe6h1vkyrYHpfYp43CZjHdeExEMP/hE7dFy1FQOUJyIHPtrdjgCWUigsfP6JBtkKySrIKsKkh9o/hGORVBb+X3nAJySsEB6BJ0QC686N3YDDhixhxLMF4e891DsPv9kT3IPwjWSZQFVt0Cqv69k32HaAKAd/FxDrYqEMyBfLcnVWLOUxA88pMhwa642tUIgr8RrIptBX7AKr2Lj3NiqTKJuSFjITnBLuWmTrDjoyGWclVksYQE+8a+nJ7KpcdEmFORlBSBhdmNMTUWFIBG+7mHJvseekyGdcsMdRfRUARL02rNRPmo7qRISaEVBbPU6cCkOdBfq6VUoMJf3qtCuJY2qFkDIWt+wKoCgPDRUgiBUZLTTBICa19t2SEQ22yHj5ZCMhnJGcvsNijH5ICe08ROaSkk5aVNVxJr/tbJMF7Wd1zaKS2FwMs3Jin95IAh58Gd0juhkNeNR5URhHLdv9dPDhhx4N35+UIAYNdUULoYO87J3Zt3Xw2GvR55ov9u74IHwW7Wu5ZUk1OssgC7X999xRtlPvbKYnvvvCfChEpmNL+OdCO7G/dPeeNcaN3JbO+97QHYnziWsVYc8mqwPcH9jfuvezotal86WS3J7mo9pcAWqB2LNsFi6Xx9omgM7Ab84qm6rm22V/czuLXRJvjxR09zXQX/A5lOk19++k9upGEM2gRFWqcTR6SBSfpJRZZ2LNoEFeBOEIshRK6uZQIFqd1r5rNXPxZtghRo5/0UkP0YBOkMeaHtIkM4uoZJlonh/3cZCDOXTElj0SLYt0TMAHzNpUKLoKklohdJkr2puVRoEUyzRJgaoUrpxaSpoP60PAiEVCBcDn48x9s/nKWiLINSSeMTkWjFZGs5E+SG3uCPAlEhxA9+eqscL74VnisDcG94z1y0P1e/r+GrOyRSawzqEUyOiij4Wz3EenErfLOMDlHCB9gmmmFeZ0qQQAUS+VsPFstJ6nWIrl995kawfOgoqglNghIe9+4gEBUC/rcPnHKaYDa3O0QPXYxLXSLU8amdDJ988DQQ4lr8CytE7cNiUHyYTDFdrF89dBWtghCXur/y8s5G8TWtU32ibM+vPnGipr1iARDbLhUfLtYnCTwp1vOHjhWdWAGAlrJKmwlO9P8BzSU4kEVllNAAAAAASUVORK5CYII=",
      "e": 1
    },
    {
      "id": "image_1",
      "w": 56,
      "h": 55,
      "u": "",
      "p": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA3CAYAAABZ0InLAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAADi0lEQVRogd2awU7bQBCGZ2YdOzFEtE0AYZQTEgH5WUjVQ96H9+kBWp4lUqjUQhURCm1EhCHBTna3BxqJhhh2491g+G/Rjr3/53G84/EiLEz7FIYtBwCg1QrHAPtiEbPiIibZCj7WQOLa/zPLy+/dLx3bczPbE2xufqo4EjYfj+CSv7KbRFF7aHN+snlyAABvLIJ5xkzJagZrtUbgSHqXNo6IbPn9Nl5fH0e2PFjMYJMxQWvPRd3HNK1daGuAtVq8zsTzdwgTwGq1eN2WD0uAatmbyGYWrQCqZm8im1k0DhiGTdcd04buce6YNsKw6Zr2Yxzwtjea+9Gf5dg0GQUMw6bLECrzHs8QKqazaBTQRAZMZ9EYYL3aKGfJ3kQMoVKvNsomPAEYBBx5TPvBsohzZX6bCMOmG/8e1SSD1JJsHiGHvrda6LRan5NM59EJrlcb5RuPuUUpfIlUEiB9nfVuHnECToADlGJ4hzRYjnly/Oercu06EzAI9nxEp0TEvYJgyzAWHhIaX6OySAqZgEPxiPiNECyWcjzsdo8G03EIcA/kCrYmQPoFxNLi7ZrTSMohAQ4S4pfd7tEAg2DPd5Ft277VFi1OwBPJvzlFTltIbwsO4L6+LQraorz9t0wKCV3rLYuXFkkhM60zeZYUMiFRQuutu5eSKGGH9fvtO39lN3Gk2UrkpXVHeNrpHF4xAIAoag/fEuQd4enZ2UEP4EHb8K1APoQDmOqLvnbIaTiAGY3f1wo5Cw4gpbMdRe3hh6VdDggr9q0ZkMDOz/ODP7OGUku0q9v27cryjkcIvj1n2cUl9E4uDs/Sxp+sQfs37X6eIbmE3umvw9OnYp4tsvMKqQIHoPh1qX/T7lf8HR8IipmdGRBy6P+4ODxRiVUutr3VQm5KOh0vyoBZmz8mpePl7b8uqQYGwV5uHjI6XpQBywnmpq2h40UZcFACY+30rNLxogzo8vxkUMeLMqBEyk2/VMeL+lN0LLy53NiQhhdlwDy1F3W8KAHmaYmYSNWTEmCeloiJVD0pAeZpiZhI1ZOjEpR1iZCEUSHm55PvevVqozzy2AYKOfeFU/WkBCiRSiiltolpsIn+/Y6ygKouFUqA2pOngE3LBOhzMgqoCjYtm6BKgDFArwjpf+p5waalAxoDPGoRzpLyJoRZ+665hJ43Fr2sYGmqVxvl2KHKo/03Gvu9NbeRvMzO+Szz/gVJ/JsiOqfPMQAAAABJRU5ErkJggg==",
      "e": 1
    }
  ],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Shape Layer 21",
      "parent": 17,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 144.775, "ix": 10 },
        "p": { "a": 0, "k": [29.145, 55.882, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [39.709, 39.709, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 88,
                "s": [100]
              },
              { "t": 99, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 111,
                "s": [100]
              },
              { "t": 121, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 84,
      "op": 364,
      "st": -6,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Shape Layer 20",
      "parent": 17,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 135, "ix": 10 },
        "p": { "a": 0, "k": [35.255, 59.445, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [62.618, 62.618, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 75,
                "s": [100]
              },
              { "t": 86, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 97,
                "s": [100]
              },
              { "t": 108, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 71,
      "op": 351,
      "st": -19,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Shape Layer 19",
      "parent": 17,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 149.036, "ix": 10 },
        "p": { "a": 0, "k": [19.473, 59.445, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [50.909, 50.909, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 69,
                "s": [100]
              },
              { "t": 80, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 91,
                "s": [100]
              },
              { "t": 102, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 65,
      "op": 345,
      "st": -25,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Shape Layer 18",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [438, 155, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 126,
                "s": [100]
              },
              { "t": 137, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 138,
                "s": [100]
              },
              { "t": 149, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 122,
      "op": 402,
      "st": 32,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "Shape Layer 17",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": -82.224, "ix": 10 },
        "p": { "a": 0, "k": [365.75, 157.25, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [69, 69, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 139,
                "s": [100]
              },
              { "t": 150, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 151,
                "s": [100]
              },
              { "t": 162, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 135,
      "op": 391,
      "st": 21,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 4,
      "nm": "Shape Layer 16",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": -98.922, "ix": 10 },
        "p": { "a": 0, "k": [354.5, 164, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [135, 135, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 118,
                "s": [100]
              },
              { "t": 129, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 130,
                "s": [100]
              },
              { "t": 141, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 115,
      "op": 408,
      "st": 38,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 4,
      "nm": "Shape Layer 15",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 78.205, "ix": 10 },
        "p": { "a": 0, "k": [442, 216.25, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [74, 74, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 126,
                "s": [100]
              },
              { "t": 137, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 138,
                "s": [100]
              },
              { "t": 149, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 122,
      "op": 391,
      "st": 21,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 8,
      "ty": 4,
      "nm": "Shape Layer 14",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 54.782, "ix": 10 },
        "p": { "a": 0, "k": [446.5, 205, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [54, 54, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 145,
                "s": [100]
              },
              { "t": 156, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 157,
                "s": [100]
              },
              { "t": 168, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 142,
      "op": 408,
      "st": 38,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 9,
      "ty": 4,
      "nm": "Shape Layer 13",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": -149.021, "ix": 10 },
        "p": { "a": 0, "k": [350, 206.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [96, 96, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 117,
                "s": [100]
              },
              { "t": 128, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 129,
                "s": [100]
              },
              { "t": 140, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 113,
      "op": 391,
      "st": 21,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 10,
      "ty": 4,
      "nm": "Shape Layer 12",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": -149.021, "ix": 10 },
        "p": { "a": 0, "k": [350, 350.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [96, 96, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 31,
                "s": [100]
              },
              { "t": 42, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 43,
                "s": [100]
              },
              { "t": 54, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 29,
      "op": 370,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 11,
      "ty": 4,
      "nm": "Shape Layer 11",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 54.782, "ix": 10 },
        "p": { "a": 0, "k": [446.5, 349, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [54, 54, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 48,
                "s": [100]
              },
              { "t": 59, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 60,
                "s": [100]
              },
              { "t": 71, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 46,
      "op": 387,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 12,
      "ty": 4,
      "nm": "Shape Layer 10",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 78.205, "ix": 10 },
        "p": { "a": 0, "k": [442, 360.25, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [74, 74, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 31,
                "s": [100]
              },
              { "t": 42, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 43,
                "s": [100]
              },
              { "t": 54, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 29,
      "op": 370,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 13,
      "ty": 4,
      "nm": "Shape Layer 9",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": -98.922, "ix": 10 },
        "p": { "a": 0, "k": [354.5, 308, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [135, 135, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 48,
                "s": [100]
              },
              { "t": 59, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 60,
                "s": [100]
              },
              { "t": 71, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 46,
      "op": 387,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 14,
      "ty": 4,
      "nm": "Shape Layer 8",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": -82.224, "ix": 10 },
        "p": { "a": 0, "k": [365.75, 301.25, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [69, 69, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 31,
                "s": [100]
              },
              { "t": 42, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 43,
                "s": [100]
              },
              { "t": 54, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 29,
      "op": 370,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 15,
      "ty": 4,
      "nm": "Shape Layer 2",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [438, 299, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [42, 96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [6.173, -8.395]
                  ],
                  "o": [
                    [-6.481, 8.815],
                    [0, 0]
                  ],
                  "v": [
                    [64, 61],
                    [39, 95]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.435294147566, 0.364705882353, 0.901960844152, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.207], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 42,
                "s": [100]
              },
              { "t": 53, "s": [0] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 54,
                "s": [100]
              },
              { "t": 65, "s": [0] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 40,
      "op": 381,
      "st": 11,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 16,
      "ty": 4,
      "nm": "chart",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 20, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [400, 406, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 206, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0, 0, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 79,
              "s": [100, 0, 100]
            },
            { "t": 100, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [77.439, 151.539], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 8, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.513725490196, 0.435294117647, 1, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0.22, 128.27], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Rectangle 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 370,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 17,
      "ty": 2,
      "nm": "star.ai",
      "cl": "ai",
      "refId": "image_0",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.071, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 29,
              "s": [400.75, 355.25, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 0.667 },
              "o": { "x": 0.333, "y": 0.333 },
              "t": 66,
              "s": [400.75, 339.25, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 79,
              "s": [400.75, 339.25, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            { "t": 100, "s": [400.75, 191.25, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [28, 28.518, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0, 0, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 29,
              "s": [144.429, 144.429, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 66,
              "s": [196.429, 196.429, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [1, 1, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
              "t": 100,
              "s": [196.429, 196.429, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [1, 1, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
              "t": 111,
              "s": [196.429, 196.429, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [1, 1, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
              "t": 120,
              "s": [239.429, 239.429, 100]
            },
            { "t": 129, "s": [196.429, 196.429, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "ip": 0,
      "op": 370,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 18,
      "ty": 2,
      "nm": "star small.ai",
      "cl": "ai",
      "refId": "image_1",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.138, "y": 0.978 },
              "o": { "x": 0.339, "y": 0 },
              "t": 20,
              "s": [740, 8, 0],
              "to": [-44.993, 133.956, 0],
              "ti": [99.992, -39.111, 0]
            },
            {
              "i": { "x": 0.663, "y": 1 },
              "o": { "x": 0.329, "y": 0.001 },
              "t": 65,
              "s": [407.131, 364.957, 0],
              "to": [-99.992, 39.111, 0],
              "ti": [0.044, -0.014, 0]
            },
            { "t": 66, "s": [400, 358, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [28, 27.5, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 19,
              "s": [0, 0, 100]
            },
            { "t": 66, "s": [81.818, 81.818, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "ip": 19,
      "op": 57,
      "st": 19,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 19,
      "ty": 2,
      "nm": "star small.ai",
      "cl": "ai",
      "refId": "image_1",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.138, "y": 0.978 },
              "o": { "x": 0.339, "y": 0 },
              "t": 9,
              "s": [640, 8, 0],
              "to": [-93.993, 58.956, 0],
              "ti": [30.992, -96.111, 0]
            },
            {
              "i": { "x": 0.663, "y": 1 },
              "o": { "x": 0.329, "y": 0.001 },
              "t": 47,
              "s": [400.131, 344.957, 0],
              "to": [-30.992, 96.111, 0],
              "ti": [0.044, -0.014, 0]
            },
            { "t": 48, "s": [400, 358, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [28, 27.5, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 8,
              "s": [0, 0, 100]
            },
            { "t": 48, "s": [81.818, 81.818, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "ip": 8,
      "op": 48,
      "st": 8,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 20,
      "ty": 2,
      "nm": "star small.ai",
      "cl": "ai",
      "refId": "image_1",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.131, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 0,
              "s": [690, -32, 0],
              "to": [-18, 113, 0],
              "ti": [113, -37, 0]
            },
            { "t": 40, "s": [400, 358, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [28, 27.5, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 0,
              "s": [0, 0, 100]
            },
            { "t": 40, "s": [81.818, 81.818, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "ip": 0,
      "op": 40,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
